import { render, staticRenderFns } from "./smallRadioBox.vue?vue&type=template&id=ab83bcd6&scoped=true&"
import script from "./smallRadioBox.vue?vue&type=script&lang=js&"
export * from "./smallRadioBox.vue?vue&type=script&lang=js&"
import style0 from "./smallRadioBox.vue?vue&type=style&index=0&id=ab83bcd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab83bcd6",
  null
  
)

export default component.exports